<template>
  <v-dialog
    :model-value="open"
    max-width="900px"
    scrollable
    persistent
    @update:model-value="onDialogUpdate"
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <span>Review Workflow Document</span>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" size="small" :disabled="submitting" @click="onDiscard" />
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-alert
          v-if="errorMessage"
          type="error"
          density="compact"
          variant="tonal"
          class="mb-4"
        >
          {{ errorMessage }}
        </v-alert>
        <v-alert
          type="warning"
          density="compact"
          variant="outlined"
          class="mb-4"
        >
          Do not refresh the page or navigate away until you send or discard this workflow document. The review draft
          will be lost if the page reloads.
        </v-alert>
        <v-textarea
          :model-value="modelValue"
          label="Workflow Document"
          variant="outlined"
          rows="18"
          auto-grow
          hide-details
          @update:model-value="onModelUpdate"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-4 py-3">
        <v-btn variant="text" :disabled="submitting" @click="onDiscard">
          Discard
        </v-btn>
        <v-spacer />
        <v-btn
          color="secondary"
          variant="outlined"
          :disabled="submitting || !canSubmitToCurrentChat || !hasContent"
          @click="$emit('submit-to-current-chat')"
        >
          Send To Current Chat
        </v-btn>
        <v-btn
          color="primary"
          :loading="submitting"
          :disabled="submitting || !hasContent"
          @click="$emit('submit-to-new-chat')"
        >
          Start New Chat
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'WorkflowVideoReviewDialog',
  props: {
    open: {
      type: Boolean,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    submitting: {
      type: Boolean,
      required: true
    },
    errorMessage: {
      type: String,
      default: null
    },
    canSubmitToCurrentChat: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:open', 'update:modelValue', 'submit-to-current-chat', 'submit-to-new-chat', 'discard'],
  computed: {
    hasContent(): boolean {
      return this.modelValue.trim().length > 0
    }
  },
  methods: {
    onDialogUpdate(value: boolean): void {
      this.$emit('update:open', value)
    },
    onModelUpdate(value: string): void {
      this.$emit('update:modelValue', value)
    },
    onDiscard(): void {
      this.$emit('discard')
    }
  }
})
</script>
